export default {
  home: "Kezdőlap",
  aboutUs: "Rólunk",
  capabilities: "Képességek",
  esg: "Fenntarthatóság",
  careers: "Karrier",
  contact: "Kapcsolat",
  ourJourney: "Utazásunk",
  visionMission: "Vízió és küldetés",
  leadershipTeam: "Vezetői csapat",
};

